<div class="container-fluid">
  <div class="row">
    <!-- Home body -->
    <div class="mb-3 col-md-9">
      <!-- Stylized Breadcrumb -->
      <div class="jumbotron">
        <h1 class="display-4">System Proof dashboard</h1>
        <p class="lead">
          The System Proof dashboard is part of the MOSAR platform, which
          provides a methodology and a suite of tools to design and validate the
          safety of driving automation systems using a scenario database.
        </p>

        <hr class="my-4" />
        <ng-container id="home-breadcrumb">
          <div class="d-flex sections-nav">
            <button class="btn" [routerLink]="SYSTEMS_URL">
              <span class="title">
                <mat-icon>fact_check</mat-icon>
                Driving Automation Systems
              </span>
              <p class="description">
                Explore and manage various driving automation systems.
              </p>
            </button>
            <button class="btn" [routerLink]="CAMPAIGNS_URL">
              <span class="title">
                <mat-icon>view_list</mat-icon>
                Campaigns
              </span>
              <p class="description">
                View and organize campaigns related to system testing.
              </p>
            </button>
            <button class="btn" [routerLink]="USECASES_URL">
              <span class="title">
                <mat-icon>commute</mat-icon>
                Use-cases
              </span>
              <p class="description">
                Access and analyze different use-cases for testing.
              </p>
            </button>
            <button class="btn" [routerLink]="TESTS_PROTOCOL_URL">
              <span class="title">
                <mat-icon>fact_check</mat-icon>
                Test Protocols
              </span>
              <p class="description">
                Review and manage test protocols for validation.
              </p>
            </button>
          </div>
        </ng-container>
      </div>

      <!-- Quick navigation -->
      <div class="card bg-light">
        <div class="card-header" class="text-white bg-sysx-lightblue p-2">
          <mat-icon
            role="img"
            class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color"
            aria-hidden="true"
            data-mat-icon-type="font"
            >dashboard</mat-icon
          >
          <span class="chart-title"> Quick navigation</span>
        </div>

        <div class="card-body">
          <p>
            The quick navigation section below allows you to quickly access
            campaigns, test protocols, and use-cases related to a specific
            driving automation system.
          </p>

          <ng-container *ngIf="!campaignsLoaded">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </ng-container>
          <div
            class="row"
            *ngIf="systems && systems.length && systems.length > 0"
          >
            <div class="col-md-3">
              <div class="container-fluid">
                <h5 style="min-height: 50px">
                  <mat-icon>fact_check</mat-icon>
                  Driving Automation Systems
                </h5>
                <ng-container *ngIf="systems && systems?.length">
                  <div *ngFor="let system of systems" class="row">
                    <div class="btn-group">
                      <button
                        class="btn margin-bottom-5px text-left"
                        [ngClass]="{
                          'btn-primary': system?.id === systemSelected?.id,
                          'btn-light': system?.id !== systemSelected?.id
                        }"
                        (click)="selectSystem(system)"
                      >
                        {{ system.name }}
                        <app-notification-badge
                          *ngIf="system && system.nbCampaigns !== undefined"
                          [count]="system.nbCampaigns"
                          [tooltip]="
                            system.nbCampaigns +
                            ' campaign(s) defined in this system'
                          "
                        >
                        </app-notification-badge>
                        <div class="float-right">
                          <mat-icon>keyboard_arrow_right</mat-icon>
                        </div>
                      </button>
                      <button
                        class="btn margin-bottom-5px"
                        [ngClass]="{
                          'btn-primary': system?.id === systemSelected?.id,
                          'btn-light': system?.id !== systemSelected?.id
                        }"
                        style="max-width: 60px"
                        (click)="redirectToSystem(system)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-md-3">
              <div class="container-fluid" *ngIf="systemSelected">
                <h5 style="min-height: 50px">
                  <mat-icon>view_list</mat-icon>
                  Related campaigns
                </h5>
                <span class="text-muted" *ngIf="!systemSelected"
                  ><i><small>Select a campaign to filter</small></i></span
                >
                <div
                  *ngFor="
                    let campaign of campaignContainers
                      | filterCampaignBySystem : systemSelected
                  "
                  class="row"
                >
                  <div class="btn-group">
                    <button
                      class="btn margin-bottom-5px text-left"
                      [ngClass]="{
                        'btn-primary': campaign?.id === campaignSelected?.id,
                        'btn-light': campaign?.id !== campaignSelected?.id
                      }"
                      (click)="selectCampaign(campaign)"
                    >
                      {{ campaign.name }}
                      <app-notification-badge
                        *ngIf="
                          campaign &&
                          campaign?.campaign &&
                          campaign?.campaign?.resources[0] &&
                          campaign?.campaign?.resources[0].testProtocols
                        "
                        [count]="
                          campaign?.campaign?.resources[0].testProtocols.length
                        "
                        [tooltip]="
                          campaign?.campaign?.resources[0].testProtocols
                            .length +
                          ' test protocol(s) defined in this campaign'
                        "
                      >
                      </app-notification-badge>
                      <div class="float-right">
                        <mat-icon>keyboard_arrow_right</mat-icon>
                      </div>
                    </button>
                    <button
                      class="btn margin-bottom-5px"
                      [ngClass]="{
                        'btn-primary': campaign?.id === campaignSelected?.id,
                        'btn-light': campaign?.id !== campaignSelected?.id
                      }"
                      style="max-width: 60px"
                      (click)="redirectToCampaign(campaign)"
                    >
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="container-fluid" *ngIf="campaignSelected">
                <h5 style="min-height: 50px">
                  <mat-icon>fact_check</mat-icon>
                  Related test protocols
                </h5>
                <span class="error" *ngIf="!campaignSelected"
                  >You must select a campaign before</span
                >
                <ng-container *ngIf="testProtocols && testProtocols?.length">
                  <div
                    *ngFor="
                      let testProtocol of testProtocols
                        | filterTestProtocolByCampaign : campaignSelected
                    "
                    class="row"
                  >
                    <div class="btn-group">
                      <button
                        class="btn margin-bottom-5px text-left"
                        [ngClass]="{
                          'btn-primary':
                            testProtocol?.id === testProtocolSelected?.id,
                          'btn-light':
                            testProtocol?.id !== testProtocolSelected?.id
                        }"
                        (click)="selectTestProtocol(testProtocol)"
                      >
                        {{ testProtocol.name }}
                        <app-notification-badge
                          *ngIf="
                            testProtocol && testProtocol?.testScenarios?.length
                          "
                          [count]="testProtocol?.testScenarios?.length"
                          [tooltip]="
                            testProtocol?.testScenarios?.length +
                            ' usecase(s) defined in this test protocol'
                          "
                        >
                        </app-notification-badge>
                        <div class="float-right">
                          <mat-icon>keyboard_arrow_right</mat-icon>
                        </div>
                      </button>
                      <button
                        class="btn margin-bottom-5px"
                        [ngClass]="{
                          'btn-primary':
                            testProtocol?.id === testProtocolSelected?.id,
                          'btn-light':
                            testProtocol?.id !== testProtocolSelected?.id
                        }"
                        style="max-width: 60px"
                        [disabled]="!campaignSelected"
                        (click)="redirectToTestProtocol(testProtocol)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-md-3">
              <div class="container-fluid" *ngIf="testProtocolSelected">
                <h5 style="min-height: 50px">
                  <mat-icon>commute</mat-icon>
                  Related usecase
                </h5>
                <span class="error" *ngIf="!testProtocolSelected"
                  >You must select a test protocol before</span
                >
                <ng-container *ngIf="usecases && usecases?.length">
                  <div
                    *ngFor="
                      let uc of usecases
                        | filterUsecaseByTestProtocol : testProtocolSelected
                    "
                    class="row"
                  >
                    <div class="btn-group">
                      <button
                        class="btn margin-bottom-5px text-left"
                        [ngClass]="{
                          'btn-primary': uc?.id === usecaseSelected?.id,
                          'btn-light': uc?.id !== usecaseSelected?.id
                        }"
                        (click)="selectUsecase(uc)"
                      >
                        {{ uc.usecase.name }}
                      </button>
                      <button
                        class="btn margin-bottom-5px"
                        [ngClass]="{
                          'btn-primary': uc?.id === usecaseSelected?.id,
                          'btn-light': uc?.id !== usecaseSelected?.id
                        }"
                        style="max-width: 60px"
                        [disabled]="!testProtocolSelected"
                        (click)="redirectToUseCase(uc)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              campaignsLoaded &&
              ((systems && !systems.length) ||
                (systems && systems.length && systems.length === 0))
            "
          >
            <span class="text-muted"><i>No available campaign</i></span>
          </div>
        </div>
      </div>
    </div>
    <!-- Documentation box -->
    <div class="col-md-3">
      <div class="card">
        <div class="card-header bg-sysx-lightblue text-light">
          <mat-icon>menu_book</mat-icon>
          Documentation
        </div>
        <div class="card-body overflow-auto">
          <h5>Key documentation</h5>
          <ul>
            <li>
              <a
                href="{{ docBaseUrl }}MOSAR-UseCase-DataModel-Reference.html"
                triggers="hover"
                container="body"
                ngbtooltip="data model reference html format"
                target="_blank"
                >Usecases data model reference</a
              >&nbsp;
              <a
                href="{{ docBaseUrl }}MOSAR-UseCase-DataModel-Reference.pdf"
                triggers="hover"
                container="body"
                ngbtooltip="data model reference pdf format"
                target="_blank"
              >
                <mat-icon>picture_as_pdf</mat-icon>
              </a>
            </li>
            <li>
              <a
                href="{{ docBaseUrl }}MOSAR-UserGuide.html"
                triggers="hover"
                container="body"
                ngbtooltip="user guide html format"
                target="_blank"
                >Dashboard user's guide</a
              >&nbsp;
              <small
                ><a
                  href="{{ docBaseUrl }}MOSAR-UserGuide.pdf"
                  triggers="hover"
                  container="body"
                  ngbtooltip="user guide pdf format"
                  target="_blank"
                >
                  <mat-icon>picture_as_pdf</mat-icon>
                </a></small
              >
            </li>
          </ul>
          <h5>Technical documentation</h5>
          <ul>
            <li>
              <a href="/swagger/scenariomanager/" target="_blank"
                >Scenario manager API reference</a
              >
            </li>
            <li>
              <a href="/swagger/statistics/" target="_blank"
                >Statistics API reference</a
              >
            </li>
            <li>
              <a
                href="{{ docBaseUrl }}MOSAR-Python-Tutorial.html"
                triggers="hover"
                container="body"
                ngbtooltip="Python tutorial html format"
                target="_blank"
                >Python client documentation</a
              >&nbsp;
            </li>
          </ul>
        </div>
        <div class="card-footer">
          <mat-icon>contact_support</mat-icon> Contact:
          <a href="{{ supportEmail }}">{{ supportEmail }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
